import { tooltip } from '../tooltip';

export const typeToDateFormat = type => {
  switch (type) {
    case 'days':
    case 'weeks':
      return 'DD.MM';
    case 'years':
      return 'YYYY';
    case 'months':
    default:
      return 'MMM';
  }
};

export const pushData = (
  chartArr,
  date,
  count,
  colors = [],
  data1 = 0,
  data2 = 0,
  data3 = 0
) => {
  switch (count) {
    case 3: {
      chartArr.push([
        date,
        tooltip(
          date,
          [data1, data2, data3],
          [chartArr[0][2], chartArr[0][4], chartArr[0][6]],
          colors
        ),
        data1,
        'point {  stroke-color: #fff; stroke-width: 1; }',
        data2,
        'point { stroke-color: #fff; stroke-width: 1; }',
        data3,
        'point { stroke-color: #fff; stroke-width: 1; }'
      ]);
      break;
    }
    case 2: {
      chartArr.push([
        date,
        tooltip(date, [data1, data2], [chartArr[0][2], chartArr[0][4]], colors),
        data1,
        'point {  stroke-color: #fff; stroke-width: 1; }',
        data2,
        'point { stroke-color: #fff; stroke-width: 1; }'
      ]);
      break;
    }
    case 1: {
      chartArr.push([
        date,
        tooltip(date, [data1], [chartArr[0][2]], colors),
        data1,
        'point {  stroke-color: #fff; stroke-width: 1; }'
      ]);
      break;
    }
    default: {
      chartArr.push(['', 0, 'point {  stroke-color: #fff; stroke-width: 1; }']);
    }
  }
};
